export default __webpack_public_path__ + "static/media/icon-cps.c6d7337b.svg";